module.exports = __webpack_public_path__ + "static/media/infocomm.0be48fb1.png";